export const MenuFontController = () => {

  $('.toggle-menu').on('click', function() {
    if ($(window).width() > 768) {
      let fontSize = $(".offscreen-menu-wrapper").height() * 0.03;
      $('.main-nav__item').css('font-size', fontSize);
    }
    else {
      let fontSize = $(".offscreen-menu-wrapper").height() * 0.025;
      $('.main-nav__item').css('font-size', fontSize);
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/controllers/MenuFontController.js